export default 'prod';



// WEBPACK FOOTER //
// ./src/settings/Mode.js